import { Grid, Typography } from '@mui/material';

const Image = (props) => {
  return (
    <Grid container overflow='hidden' direction='column' justifyContent='center' alignItems='center'>
      <Grid
        item
        component='img'
        sx={{
          borderRadius: '1rem',
          objectFit: 'cover',
          maxHeight: { xs: 233, md: 400, lg: 400 },
          mt: '1rem',
          mb: '1rem',
        }}
        alt='Blog image'
        src={`https://hnjiwdxlyyttjbocwpfw.supabase.co/storage/v1/object/public/blog/images/${props.filename.src}`}
      />
      {props.filename.caption && (
        <Grid item>
          <Typography variant='caption'>{props.filename.caption}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default Image;
